import React from 'react';
import styles from './index.module.css';
import logo from '../../assets/logo-main.webp';
import { FaInstagram } from 'react-icons/fa6';
import { FaFacebookF } from 'react-icons/fa6';
import { FaLinkedinIn } from 'react-icons/fa6';

const Footer = () => {
  const socials = [
    {
      id: 1,
      icon: <FaInstagram />,
      link: 'https://www.instagram.com/epinics_pos',
      name: 'Instagram',
    },
    {
      id: 2,
      icon: <FaFacebookF />,
      link: 'https://www.facebook.com/epinicspos',
      name: 'Facebook',
    },
    {
      id: 3,
      icon: <FaLinkedinIn />,
      link: 'https://www.linkedin.com/company/epinics',
      name: 'LinkedIn',
    },
  ];
  return (
    <div className={styles.mainDiv}>
      <div className={styles.innerDiv}>
        <div className={styles.left}>
          <div className={styles.logoDiv}>
            <img
              className={styles.logo}
              src={logo}
              alt={logo.toString()}
              loading="lazy"
            />
            <div className={styles.name}>EPINICS</div>
          </div>
          <div className={styles.description}>
            Ours Pos Software is the ultimate solution designed to transform
            your business operations into a streamlined and efficient
            powerhouse. With a focus on simplicity, versatility, and
            cutting-edge technology.
          </div>
          <div className={styles.socialLinks}>
            {socials.map((item, index) => (
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.a}
              >
                <div className={styles.social}>{item.icon}</div>
              </a>
            ))}
          </div>
        </div>
        <div className={styles.mid}>
          <div className={styles.quickLinks}>
            <div className={styles.title}>Quick Links</div>

            <a href="#home" className={styles.a}>
              <div className={styles.subTitle}>Home</div>
            </a>
            <a href="#features" className={styles.a}>
              <div className={styles.subTitle}>Features</div>
            </a>
            <a href="#pricing" className={styles.a}>
              <div className={styles.subTitle}>Pricing</div>
            </a>
            <a href="#" className={styles.a}>
              <div className={styles.subTitle}>Blog</div>
            </a>
            <a href="/contact" className={styles.a}>
              <div className={styles.subTitle}>Contact</div>
            </a>
          </div>
          <div className={styles.supports}>
            <div className={styles.title}>Supports</div>
            <a href="#faq" className={styles.a}>
              <div className={styles.subTitle}>Faq's</div>
            </a>
            <a href="/terms-and-conditions#terms-and-conditions" target="_blank" className={styles.a}>
              <div className={styles.subTitle}>Terms & Conditions</div>
            </a>
            <a href="/terms-and-conditions#privacy-policy" target="_blank" className={styles.a}>
              <div className={styles.subTitle}>Privacy Policy</div>
            </a>
            <a href="/terms-and-conditions#return-policy" target="_blank" className={styles.a}>
              <div className={styles.subTitle}>Return & Refund Policy</div>
            </a>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.newsletter}>
            <div className={styles.title}>Subscribe Newsletter</div>
            <div className={styles.subscribeForm}>
              <input
                type="email"
                placeholder="Your email address"
                className={styles.input}
              />
              <button className={styles.button}>
                Send <span className={styles.arrow}>↗</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
